// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50')
];

export const server_loads = [0,2];

export const dictionary = {
		"/": [~5],
		"/admin": [~6,[2]],
		"/admin/customer": [~7,[2]],
		"/admin/customer/newcustomer": [9,[2]],
		"/admin/customer/[customerId]": [~8,[2]],
		"/admin/forgot": [10,[2]],
		"/admin/menu": [~11,[2]],
		"/admin/menu/newmenu": [~13,[2]],
		"/admin/menu/[menuId]": [~12,[2]],
		"/admin/order": [~14,[2]],
		"/admin/order/neworder": [~17,[2]],
		"/admin/order/[orderId]": [~15,[2]],
		"/admin/order/[orderId]/create-invoice": [~16,[2]],
		"/admin/reset": [18,[2]],
		"/admin/settings": [~19,[2]],
		"/admin/signin": [20,[2,3]],
		"/admin/signup": [21,[2]],
		"/admin/site-setting": [~22,[2]],
		"/admin/tenants": [~23,[2]],
		"/admin/text": [~24,[2]],
		"/alergeny": [~25],
		"/auth": [26,[4]],
		"/auth/error": [27,[4]],
		"/auth/forgot": [28,[4]],
		"/auth/login": [~29,[4]],
		"/auth/reactivate": [~30,[4]],
		"/auth/reset": [~31,[4]],
		"/auth/signup": [32,[4]],
		"/auth/signup/complete": [~33,[4]],
		"/cenik": [~34],
		"/gdpr": [~35],
		"/haccp": [~36],
		"/kontakt": [~37],
		"/kosik": [38],
		"/mgr-bc-kamila-forejtova": [~39],
		"/mgr-martin-forejt-phd": [~40],
		"/obchodni-podminky": [~41],
		"/obedy": [~42],
		"/olga-bednarova": [~43],
		"/poradna": [~44],
		"/prednasky-a-kurzy": [~45],
		"/profile": [~46],
		"/test-refresh-token": [48],
		"/test": [47],
		"/thankyou": [~49],
		"/version": [50]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);